import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/contact",
    name: "Contact",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Contact.vue")
  },
  {
    path: "/participant-information",
    name: "ParticipantInformation",
    component: () => import("../views/ParticipantInformation.vue")
  },
  {
    path: "/privacy-policy",
    name: "Privacy policy",
    component: () => import("../views/PrivacyPolicy.vue")
  },
  {
    path: "/our-team",
    name: "Our team",
    component: () => import("../views/Team.vue")
  },
  {
    path: "/useful-links",
    name: "Useful links",
    component: () => import("../views/UsefulLinks.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

export default router;
